var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactKeycloakProvider } from '@react-keycloak/web';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { api, axiosInstance } from '../../services/api.service';
import { getUserInfo } from '../../services/auth.service';
import { keycloak as keycloakInstance } from '../../services/keycloak.service';
import { AuthContext } from './AuthContext';
import { getAuthDataFromLocalStorage, handleLogin, handleLogout, saveAuthDataToLocalStorage, useSetupInterceptors, } from './auth.utils';
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState({}), userInfo = _b[0], setUserInfo = _b[1];
    var _c = useState(null), authProvider = _c[0], setAuthProvider = _c[1];
    var _d = useState(false), isAuthenticated = _d[0], setIsAuthenticated = _d[1];
    var _e = useState(false), internalInitialized = _e[0], setInternalInitialized = _e[1];
    var _f = useState(false), keycloakInitialized = _f[0], setKeycloakInitialized = _f[1];
    var navigate = useNavigate();
    var addMessage = function (status, message) {
        enqueueSnackbar({
            message: message,
            variant: status,
        });
    };
    useSetupInterceptors(axiosInstance, navigate, addMessage);
    // Função para buscar o perfil do usuário
    var fetchUserProfile = useCallback(function (provider, token) { return __awaiter(void 0, void 0, void 0, function () {
        var userInfoData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setAuthProvider(provider);
                    saveAuthDataToLocalStorage(token, provider);
                    api.setAuthorizationToken(provider, token);
                    return [4 /*yield*/, getUserInfo()];
                case 1:
                    userInfoData = _a.sent();
                    setUserInfo(userInfoData);
                    setIsAuthenticated(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Falha ao obter informação de perfil', error_1);
                    setIsAuthenticated(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var hasPermission = function (permissao) {
        if (!userInfo) {
            return false;
        }
        var _a = permissao.split(':'), menu = _a[0], acao = _a[1];
        return userInfo.permissoes.includes("".concat(menu, ":").concat(acao));
    };
    var loginWithToken = function (token) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchUserProfile('internal', token)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // Inicialização da autenticação
    useEffect(function () {
        var isCancelled = false;
        var _a = getAuthDataFromLocalStorage(), provider = _a.provider, token = _a.token;
        if (provider === 'internal' && token && !isCancelled) {
            fetchUserProfile(provider, token).finally(function () {
                setInternalInitialized(true);
            });
        }
        else {
            setInternalInitialized(true); // Se não houver dados de autenticação `internal`, marque como inicializado
        }
        return function () {
            isCancelled = true;
        };
    }, [fetchUserProfile]);
    return (_jsx(ReactKeycloakProvider, { authClient: keycloakInstance, initOptions: {
            onLoad: 'check-sso',
            checkLoginIframe: false,
        }, onTokens: function (tokens) {
            if ((tokens === null || tokens === void 0 ? void 0 : tokens.token) && !isAuthenticated) {
                fetchUserProfile('mt-login', tokens.token).finally(function () {
                    return setKeycloakInitialized(true);
                });
            }
            else {
                setKeycloakInitialized(true);
            }
        }, children: _jsx(AuthContext.Provider, { value: {
                userInfo: userInfo,
                initialized: internalInitialized && keycloakInitialized,
                isAuthenticated: isAuthenticated,
                hasPermission: hasPermission,
                login: function (provider) {
                    return handleLogin(provider, keycloakInstance, navigate);
                },
                loginWithToken: loginWithToken,
                logout: function () {
                    return handleLogout(authProvider, keycloakInstance, navigate, function () {
                        setUserInfo({});
                        setIsAuthenticated(false);
                    });
                },
            }, children: children }) }));
};
